import Brochures from "@components/Components/HomeComponent/EH/Brochures";
import { getBrand } from "@components/config/helpers";
import { handleRateLimit } from "utils/handleRateLimit";


//Dynamically load the home component and return it
const Page = ({data}) => {

    return (
        <>
            <Brochures {...data} />
        </>
    );
};

export async function getServerSideProps({ query, res }) {
    try {
        if(!getBrand('EH')){
            return {notFound: true}
        }
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}contact-us`);
        const data = await req.json();

        const rateLimitRedirect = handleRateLimit(data);
        if (rateLimitRedirect) return rateLimitRedirect;

    
        return {
            props: {
                data
            },
        };
        
    } catch (error) {
        console.log(error)
        return {notFound: true} //404
    }
}

export default Page;
